import { fontWeight } from '../../../theme/typography';
import { HFlex, VFlex } from '../../../components/FlexContainers';
import { palette } from '../../../theme/palette';
import { PrimaryButton } from '../../../components/Buttons';
import { styled, Typography } from '@mui/material';

export const Root = styled(VFlex)``;

export const SeeMoreContainer = styled(HFlex)`
  min-height: 42px;
  align-items: center;
  justify-content: flex-end;
  margin-top: 20px;
`;

export const SeeMore = styled(PrimaryButton)`
  min-height: 42px;
  width: 100%;
  max-width: 144px;
  padding: 5px;
  border-radius: 5px;
  background: none;
  border: 1px solid ${palette.primary.main};
  color: ${palette.custom.darkGrey};
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.7px;
  font-weight: ${fontWeight.bold};

  :hover {
    background: ${palette.primary.main};
    color: ${palette.custom.white};
  }
`;

export const PaginationDetails = styled(Typography)`
  color: ${palette.primary.main};
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: 0.35px;
  cursor: pointer;
  margin-left: auto;
  color: ${palette.custom.darkGrey};
  text-align: right;
`;
